import store from '@/store';

export default [
  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/',
    name: 'Root',
    redirect: {
      name: 'dashboard'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
      title: '404'
    },
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  },
  {
    path: '/403',
    meta: {
      public: true,
      title: '403'
    },
    name: 'AccessDenied',
    component: () => import('@/views/AccessDenied.vue')
  },
  {
    path: '/login',
    meta: {
      public: true,
      title: 'Login'
    },
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/newPassword/:token/:dateToken',
    meta: {
      public: true,
      title: 'Nova Senha'
    },
    name: 'newPassword',
    component: () => import('@/views/NewPassword.vue')
  },
  {
    path: '/dashboard',
    meta: {
      public: false,
      title: 'Início'
    },
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      let config = store.getters['authentication/getConfig'];

      config.DEV_MODULE ? next({ path: '/dev' }) : next();
    }
  },
  {
    path: '/permissions',
    meta: {
      public: false,
      title: 'Permissions'
    },
    name: 'permissions',
    component: () => import('@/views/Permissions.vue'),
    beforeEnter: (to, from, next) => {
      const { roles } = JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.user;

      roles.includes('Admin Vue') ? next() : next({ path: '/403' });
    }
  },
  {
    path: '/dev',
    meta: {
      public: false,
      title: 'Page Development'
    },
    name: 'dev',
    component: () => import('@/views/dev/index.vue')
  },
  {
    path: '/passwordParameters',
    meta: {
      public: false,
      title: 'Password Parameters'
    },
    name: 'passwordParameters',
    component: () => import('@/views/PasswordParameters.vue'),
    beforeEnter: (to, from, next) => {
      const { roles } = JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.user;

      roles.includes('Admin Vue') ? next() : next({ path: '/403' });
    }
  },
  {
    path: '/page',
    meta: {
      public: false
    },
    name: 'Page',
    props: true,
    component: () => import('@/views/Page.vue')
  }
];
